import "datatables.net"
import "datatables.net-bs4"
import DataTable from "datatables.net-dt"

const OPTIONS = {
  searching: false,
  paging: false,
  info: false,
  columnDefs: [{ targets: "_all", orderSequence: ["asc", "desc"] }],
}

let danishOrderingApplied = false

function applyDanishOrdering() {
  if (danishOrderingApplied || !window.Intl) { return }

  const collator = new window.Intl.Collator("da")
  const types = DataTable.ext.type
  delete types.order["string-pre"]
  types.order["string-asc"] = collator.compare
  types.order["string-desc"] = (a, b) => collator.compare(a, b) * -1
  danishOrderingApplied = true
}

function initialOrder(table) {
  const column = table.dataset.jsOrderColumn
  if (column === undefined || column === "") { return null }

  return [[Number(column), table.dataset.jsOrderDir || "asc"]]
}

export function initSortableTables(root = document) {
  const tables = Array.from(root.querySelectorAll("table.table-js-sortable"))
    .filter(table => !DataTable.isDataTable(table))
  if (tables.length === 0) { return }

  applyDanishOrdering()
  tables.forEach(table => {
    const order = initialOrder(table)
    new DataTable(table, order ? { ...OPTIONS, order } : OPTIONS)
  })
}

let scheduled = false
function scheduleInit() {
  if (scheduled) { return }

  scheduled = true
  requestAnimationFrame(() => {
    scheduled = false
    initSortableTables()
  })
}

$(document).on("turbo:load", () => initSortableTables())

new MutationObserver(scheduleInit).observe(document.documentElement, {
  childList: true,
  subtree: true,
})
